import { jsx as _jsx } from "react/jsx-runtime";
import { CatButton } from '@blocks-react/components/Button';
import { Conditional } from '../../../common';
import { CatIconChevronUp } from '@blocks-react/components/Icons/ChevronUp';
import { CatIconChevronDown } from '@blocks-react/components/Icons/ChevronDown';
export const AssociatedDealerSearchResultExpander = ({ handleExpander, isExpanded, disabled, }) => {
    const chevronUpIcon = (_jsx(CatIconChevronUp, { size: "lg", "data-testid": "expander-icon-close", slot: "before" }));
    const chevronDownIcon = (_jsx(CatIconChevronDown, { size: "lg", "data-testid": "expander-icon-open", slot: "before" }));
    return (_jsx(CatButton, { onClick: handleExpander, size: "sm", variant: "ghost", hideText: true, disabled: disabled, children: _jsx(Conditional, { test: isExpanded, fallback: chevronDownIcon, children: chevronUpIcon }) }));
};
